/* Keep CMS and asynchronously inserted links aligned with the shared process page. */
(function () {
  'use strict';
  const t = (text, params) => window.LRSI18n?.t(text, params) ?? String(text).replace(/\{(\w+)\}/g, (match, key) => params && Object.prototype.hasOwnProperty.call(params, key) ? String(params[key]) : match);
  var script = document.currentScript;
  var localHosts = [window.location.hostname];
  ['shopDomain', 'permanentDomain'].forEach(function (key) {
    var host = script && script.dataset[key];
    if (host) localHosts.push(host.toLowerCase());
  });
  function localHost(host) {
    host = host.toLowerCase().replace(/^www\./, '');
    return localHosts.some(function (entry) { return entry.replace(/^www\./, '') === host; });
  }
  function resolve(value) {
    if (!value) return value;
    var candidate = value.trim();
    if (candidate.indexOf('shopify://pages/') === 0) candidate = candidate.replace('shopify://pages/', '/pages/');
    var address;
    try { address = new URL(candidate, window.location.href); } catch (_) { return value; }
    if (!/^https?:$/.test(address.protocol) || !localHost(address.hostname)) return value;
    var match = address.pathname.match(/(?:^|\/)pages\/([^/]+)\/?$/);
    if (!match) return value;
    var handle = match[1].toLowerCase();
    var fragment;
    if (handle === 'atelier' || handle === 'the-atelier') fragment = 'atelier';
    else if (handle === 'greece' || handle === 'workshop' || handle === 'the-workshop') fragment = 'workshop';
    else if (handle === 'process' || handle === 'the-process') fragment = 'process';
    else if (handle === 'the-commission') fragment = address.hash.slice(1);
    else return value;
    if (/^(materials?|samples|the-samples|the-atelier|design)$/i.test(fragment)) fragment = 'atelier';
    else if (/^(the-workshop|greece|hand-in-hand)$/i.test(fragment)) fragment = 'workshop';
    return (window.LRSI18n?.url('/pages/the-commission') || '/pages/the-commission') + address.search + (fragment ? '#' + fragment : '');
  }
  function normalize(anchor) {
    if (!anchor || anchor.nodeType !== 1 || !anchor.matches('a[href]')) return;
    var value = anchor.getAttribute('href');
    var resolved = resolve(value);
    if (resolved !== value) anchor.setAttribute('href', resolved);
  }
  function normalizeWithin(node) {
    if (!node || node.nodeType !== 1) return;
    normalize(node);
    node.querySelectorAll('a[href]').forEach(normalize);
  }
  normalizeWithin(document.documentElement);
  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest && event.target.closest('a[href]');
    normalize(target);
  }, true);
  if ('MutationObserver' in window) {
    new MutationObserver(function (records) {
      records.forEach(function (record) {
        if (record.type === 'attributes') normalize(record.target);
        else record.addedNodes.forEach(normalizeWithin);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
  }
}());
